Namespace 'Monitoring.Reports.Publications'

class Monitoring.Reports.Publications.RankingView extends Backbone.View

  className: 'ranking'
  template: JST['backbone/templates/monitoring/reports/publications/ranking']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    content_ids = Object.keys(@options.data)
    @$el.html(@template({ name: @options.name, content_ids: content_ids }))
    return this

  description_for_content: (content_id) ->
    # text: content.full_content.data.content.texto
    content = _.find(@options.contents, (content) -> content.content_id == content_id)
    @description_sliced(content)

  description_sliced: (content) ->
    result = $('<div/>')
    try
      text = @sliced_text_from_post (content)
      if !text # not empty
        text = I18n.t("monitoring.dashboard.publications.rankings.no_text_message")
        element = $('<span/>').addClass('no-text-message').html(text)
      else
        element = $('<span/>').html(text)
    catch error
      text = I18n.t("monitoring.dashboard.publications.rankings.no_text_message")
      element = $('<span/>').addClass('no-text-message').html(text)
    result.append(element).html()

  value_for_content: (content_id) ->
    @options.data[content_id]

  link_for_content_id: (content_id) ->
    content = _.find(@options.contents, (content) -> content.content_id == content_id)
    return content.link

  sliced_text_from_post: (content) ->
    post_text = content.full_content.data.texto_cortado
    if post_text == ""
      post_text = "[#{I18n.t("monitoring.dashboard.filters.filter_names.post_type_value.#{content.full_content.data.content.type}")}]"
    post_text
